export default "__VITE_ASSET__Cl$KioNC__"